export default {
    PCFotoFetched: {
        datapoint: {
            name: 'PCPhotoFetched',
            customData: (hasPhoto): [any] => [hasPhoto],
        },
    },
    BrandCardDisplayed: {
        datapoint: {
            name: 'BrandCardDisplayed',
        },
    },

    // Note: this counter-factual logging is temporarily disabled for perf reasons. See outlookweb #37295
    BrandDetectedButNotDisplayed: {
        datapoint: {
            name: 'BrandDetectedButNotDisplayed',
        },
    },
};
